import { scoresTableCols } from "@langfuse/shared";

export { scoresTableCols };
